import PropTypes from 'prop-types'
const colorSurfaceStandard = 'var(--colorSurfaceStandard, var(--coreColorNeutral0))'
import styled from 'astroturf/react'
import { MarkerItem } from '@calendly/booking-kit'
import { TitleText } from '@calendly/ui/components/typography'
import _MarkerIcon from "marker-MarkerIcon.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/details/marker.js?styleId=MarkerIcon";



const MarkerIcon = /*#__PURE__*/styled('div', null, {
  displayName: "MarkerIcon",
  styles: _MarkerIcon,
  attrs: ({
    color
  }) => ({
    style: {
      backgroundColor: color
    }
  })
})

const Marker = ({ text, color }) => (
  <MarkerItem>
    <MarkerIcon color={color} />
    <TitleText level={2} size="large">{text}</TitleText>
  </MarkerItem>
)

Marker.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
}

export default Marker
